import { Nav, Tab } from "react-bootstrap";
import { IFindingAndRecommendationDetails } from "../../../api/IFindingAndRecommendation";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { EdenMessagesGrid } from "../../../leap-components/EdenMessages/EdenMessagesGrid";
import { EdenMessagesGridType } from "../../../leap-components/EdenMessages/EdenMessagesGridProps";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  licenceProfile: ILicenceProfile;
  findingAndRecommendation: IFindingAndRecommendationDetails;
}

interface FindingAndRecommendationProps {
  licenceProfile: ILicenceProfile;
  findingAndRecommendation: IFindingAndRecommendationDetails;
}

const SubTabs = ({
  className,
  activeKey,
  licenceProfile,
  findingAndRecommendation,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="messages">Messages</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="messages">
          <EdenMessagesGrid
            edenMessagesType={EdenMessagesGridType.TaskBasedEdenMessages}
            profileNumber={licenceProfile.profileNo}
            taskId={findingAndRecommendation.taskid}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  licenceProfile,
  findingAndRecommendation,
}: FindingAndRecommendationProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="messages"
      licenceProfile={licenceProfile}
      findingAndRecommendation={findingAndRecommendation}
    />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
